import {React, useState} from "react";
import PropTypes from "prop-types";
import { ReportButton } from "../Accounts.styled";
import { AiOutlineInfoCircle, AiOutlineUpload } from "react-icons/ai";
import { Link, useParams } from "react-router-dom";
import { styled } from "styled-components";
import { FormGroup } from "../../customer/customersPage.styled";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import Parse from '../../../api/ApiConfig';


function InformationHeader({ data, type, getAFData }) {
    let { id } = useParams();
    const [loading, setLoading] = useState(false);

    //get file object from dom
    const FileUpload = (e) => {
		const file = e.target.files[0];
		if (file) {
			saveFileToParse(file);
		}
	};


    //host file on parse
	const saveFileToParse = async (file) => {
		setLoading(true);
		try {
			const sanitizedFileName = file.name.replace(/[^\w.-]+/g, "");
			const myFile = new Parse.File(sanitizedFileName, file);
			await myFile.save();
			setLoading(false);
            saveFileToApprentice(myFile?._url);
		} catch (error) {
			setLoading(false);
			toast.error("unable to save file to parse, please try again later", error);
			console.error("Error saving item:", error);
		}
	};


    //save file to db
    const saveFileToApprentice = (url)=>{
        const currentDate = new Date();
    const updatedFile = {
    url,
    date: Parse._encode(currentDate),
       }
    try {
        const AF = Parse.Object.extend("ApprenticeshipFinance");
        const AFObject = new AF();
        AFObject.id = id;
        AFObject.addUnique("report", updatedFile);
        AFObject.save().then((result) => {
            console.log("parseObject updated:", result);
            setLoading(false);
            toast.success("file successfully saved");
            getAFData();
        });
    } catch (error) {
        console.log(error);
        setLoading(false);
        toast.error("unable to save file, please try again");
    }
}

  
	return (
		<div className='space-between mt-8'>
			{type === "reportPage" ? (
				<>
					<h4 style={{ fontWeight: "600", color: "#006770" }}>
						What to report?
					</h4>
					<FormGroup>
                    <ReportButton customwidth={'true'}>
						<label className='thumbnail_label' htmlFor='report'>
							<AiOutlineUpload size={24} /> Upload File
							<input
								type='file'
								accept='xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .csv'
								name='image'
								id='report'
								onChange={FileUpload}
							/>
						</label>
                        </ReportButton>
					</FormGroup>
				</>
			) : (
				<>
					<h4 style={{ fontWeight: "600" }}>
						{(data?.name1 || "--") + " " + (data?.name2 || "--")}
					</h4>
					<div className='flex gap-4'>
						<Link to={"report"}>
							<ReportButton>Report</ReportButton>
						</Link>
						<AiOutlineInfoCircle size={24} color='red' />
					</div>
				</>
			)}
            {loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
		</div>
	);
}

export const UploadWrapper = styled.label`
	input[type="file"] {
		color: transparent;
		width: 0;
		height: 0;
		display: none;
	}
`;

InformationHeader.propTypes = {
	data: PropTypes.object,
	type: PropTypes.string,
    getAFData: PropTypes.func,
};

export default InformationHeader;
